import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import _get from 'lodash/get';

import {TableWithPaginationAndFiltration} from '../../components';
import {WbListActionsContainer, WbListsContainer} from '../index';
import {TABS} from '../../app-common/Insights/constants';

import './style.css';

class DomainInsightsTable extends Component {
  get domains() {
    const {data, tableStyle, selectedRows} = this.props;
    const tableSortingProps = [{
      id: 'count',
      desc: true,
    }];
    const headers = this.getHeaders();
    return (
      <TableWithPaginationAndFiltration
        columns={headers}
        data={data}
        pageSize={data.length}
        showPagination={false}
        defaultSorted={tableSortingProps}
        style={tableStyle}
        selectedRowIndices={selectedRows}
        filterable={false}
      />
    );
  }

  filterRenderer = ({filter, onChange}) => (
    <input
      type="text"
      maxLength="255"
      onChange={(e) => onChange(e.target.value)}
      style={{width: '100%'}}
      value={filter && filter.value ? filter.value : ''}
      placeholder={I18n.t(`insights.${TABS.DOMAIN}.table.search`)}
    />
  );

  actionsCellRenderer = (row) => {
    const domain = {
      ..._get(row, 'original', {}),
      index: row.index,
    };

    const domainName = _get(domain, 'parentDomain', '');

    return (
      <WbListActionsContainer
        listProps={{domainName}}
        withSubDomains={true}
        additionalActions={[
          {
            label: I18n.t('insights.rowAction.showFqdns'),
            id: 'show-fqdns',
            onClick: () => this.props.showFqdns(domain),
          },
          {
            label: I18n.t('insights.rowAction.showLogs'),
            id: 'show-logs',
            onClick: () => this.props.showLogs(domain),
          },
        ]}
      />
    );
  };

  getHeaders = () => {

    const { tab } = this.props;

    return [
    {
      accessor: 'actions',
      filterable: false,
      sortable: false,
      width: 70,
      Cell: this.actionsCellRenderer,
    },
    {
      Header: I18n.t(`insights.${TABS.DOMAIN}.table.parentDomain`),
      accessor: 'parentDomain',
      Filter: this.filterRenderer,
    },
    {
      Header: I18n.t(`insights.${TABS.DOMAIN}.table.category`),
      accessor: tab === TABS.CATEGORY ? 'fqdnCategories' : 'category',
      filterable: false,
      sortable: false,
      Cell: (row) => {
        const value = _get(row, tab === TABS.CATEGORY ? 'original.fqdnCategories' : 'original.categories', []);
        return value.join(', ');
      },
    },
    {
      Header: I18n.t(`insights.${TABS.DOMAIN}.table.categoryType`),
      accessor: tab === TABS.CATEGORY ? 'fqdnType' : 'type',
      filterable: false,
      sortable: false,
      Cell: (row) => {
        const value = _get(row, tab === TABS.CATEGORY ? 'original.fqdnType' : 'original.type', []);
        return value.join(', ');
      },
    },
    {
      Header: I18n.t(`insights.${TABS.DOMAIN}.table.uniqueFqdns`),
      accessor: 'uniqueFQDNs',
      filterable: false,
    },
    {
      Header: I18n.t(`insights.${TABS.DOMAIN}.table.count`),
      accessor: 'count',
      filterable: false,
    },
  ];
}

  render() {
    return (
      <>
        {this.domains}
        <WbListsContainer />
      </>
    );
  }
}

DomainInsightsTable.propTypes = {
  showLogs: PropTypes.func.isRequired,
  showFqdns: PropTypes.func.isRequired,

  tab: PropTypes.oneOf(Object.values(TABS)),

  data: PropTypes.array.isRequired,
  tableStyle: PropTypes.object,
  selectedRows: PropTypes.array,
};

DomainInsightsTable.defaultProps = {
  tableStyle: {
    flexGrow: 1,
    maxHeight: 'calc(100vh - 230px)',
  },
  selectedRows: [],
};

export default DomainInsightsTable;
